const loadingElList = document.querySelectorAll(".loading-animation");

let quickViewButtons, product;
window.addEventListener("DOMContentLoaded", () => {
  quickViewButtons = document.querySelectorAll(".quick-view-open");
  quickViewButtons.forEach((btn) => {
    btn.addEventListener("click", async () => {
      toggleQuickViewDrawer();
      product = await getProductData(btn);
      setTimeout(() => {
        setProductImages(product.media);
        setTitleSection(product);
        setProductPricing(product);
        setProductVariants(product);
        setAddtoCart(product);
        setProductDescription(product);
        setSeeMoreButton(product.handle);
      }, 500);
    });
  });
});
const closeSpanEl = document.querySelector(".quick-view__close-span");
if (closeSpanEl) {
  closeSpanEl.addEventListener("click", () => {
    toggleQuickViewDrawer();
    setTimeout(() => {
      resetLoading();
    }, 500);
  });
}
const closeX = document.querySelector(".quick-view__close-x");
if (closeX) {
  closeX.addEventListener("click", () => {
    toggleQuickViewDrawer();
    setTimeout(() => {
      resetLoading();
    }, 500);
  });
}
const toggleQuickViewDrawer = () => {
  const drawer = document.querySelector(".quick-view__overlay");
  drawer.classList.contains("active")
    ? drawer.classList.remove("active")
    : drawer.classList.add("active");
};
const getProductData = async (clickedBtn) => {
  const handle = clickedBtn.getAttribute("product-handle");
  return fetch(`/products/${handle}.js`)
    .then((response) => response.json())
    .then((product) => {
      return product;
    });
};
const setProductImages = (mediaList) => {
  const scrollContainer = document.querySelector(".quick-view__slider");
  scrollContainer.classList.remove("loading-animation");
  mediaList.forEach((media, index) => {
    let newDiv = document.createElement("div");
    if (index == 0) newDiv.classList.add("active-image");
    newDiv.classList.add("quick-view__image-block");
    newDiv.innerHTML = `<img width="300" height="300" alt="${media.alt}" src="${media.src}">`;
    scrollContainer.appendChild(newDiv);
  });
};
const setTitleSection = (product) => {
  const productTitle = document.querySelector(".quick-view__product-title");
  productTitle.classList.remove("loading-animation");
  productTitle.innerHTML = `
    <h2>${product.title}</h2>
  `;
};
const setProductPricing = (product) => {
  const priceContainer = document.querySelector(".quick-view__pricing");
  priceContainer.classList.remove("loading-animation");
  let regPrice = (product.variants[0].price / 100).toFixed(2);
  let priceEl = document.createElement("span");
  priceEl.classList.add("quick-view__regular-pricing");
  priceEl.innerHTML = "$" + regPrice;
  priceContainer.prepend(priceEl);
  if (product.variants[0].compare_at_price) {
    console.log(product.variants);
    let comparePrice = (product.variants[0].compare_at_price / 100).toFixed(2);
    let compareEl = document.createElement("span");
    compareEl.classList.add("quick-view__sale-pricing");
    compareEl.innerHTML = "$" + comparePrice;
    priceContainer.prepend(compareEl);
  }
};

let quickViewAtcButton;
const setAddtoCart = (product) => {
  const addToCartContainer = document.querySelector(".quick-view__atc");
  addToCartContainer.classList.remove("loading-animation");
  addToCartContainer.innerHTML = `
      <button class="primary-button" onclick="quickViewAdd(this, ${product.variants[0].id}, '${product.variants[0].sku}')">
        <span class="atc-text">Add to Cart</span>
        <span class="oos-text">Out of stock</span>
      </button>
    `;
  quickViewAtcButton = document.querySelector(
    ".quick-view__atc .primary-button"
  );
  stockCheck(product.variants[0]);
};

const stockCheck = (variant) => {
  quickViewAtcButton.disabled = !variant.available;
};

const excludedProductHandles = ["brave-box-subscription"];
let variantSelectEls;
const setProductVariants = (product) => {
  const variantsContainer = document.querySelector(".quick-view__variants");
  variantsContainer.classList.remove("loading-animation");
  if (
    product.variants.length > 1 &&
    !excludedProductHandles.includes(product.handle)
  ) {
    product.options.forEach((variant) => {
      let labelEl = document.createElement("label");
      let selectContainer = document.createElement("select");
      selectContainer.setAttribute("onchange", `quickViewVarSelect()`);
      labelEl.innerHTML = variant.name;
      variantsContainer.appendChild(labelEl);

      variant.values.forEach((value) => {
        let optionEl = document.createElement("option");
        optionEl.innerHTML = value;
        optionEl.setAttribute("value", value);
        selectContainer.appendChild(optionEl);
      });
      variantsContainer.appendChild(selectContainer);
    });
  }
  variantSelectEls = document.querySelectorAll(".quick-view__variants select");
};
const quickViewVarSelect = () => {
  let selectedVariant = updateVarId(product, getOptions(variantSelectEls));
  let varPrice = (selectedVariant.price / 100).toFixed(2);
  document.querySelector(".quick-view__regular-pricing").innerHTML =
    "$" + varPrice;
  quickViewAtcButton.setAttribute(
    "onclick",
    `quickViewAdd(this, ${selectedVariant.id}, '${selectedVariant.sku}')`
  );
};
const getOptions = (selectElements) => {
  let optionList = [];
  selectElements.forEach((selectEl) => {
    optionList.push(selectEl.value);
  });
  return optionList;
};
const updateVarId = (product, optionList) => {
  let selectedVariant,
    isMatch = true;
  product.variants.forEach((variant) => {
    optionList.every((option) => {
      isMatch = variant.options.indexOf(option) >= 0;
      return isMatch;
    });
    if (isMatch) selectedVariant = variant;
  });
  stockCheck(selectedVariant);
  return selectedVariant;
};

const setProductDescription = (product) => {
  const descriptionContainer = document.querySelector(
    ".quick-view__description"
  );
  descriptionContainer.classList.remove("loading-animation");
  descriptionContainer.innerHTML = `
    ${product.description}
  `;
};
const setSeeMoreButton = (handle) => {
  const seeMoreContainer = document.querySelector(".quick-view__see-more");
  seeMoreContainer.classList.remove("loading-animation");
  seeMoreContainer.innerHTML = `
    <a class="secondary-button" href="/products/${handle}">See full product</a>
  `;
};

const quickViewAdd = async (e, vid, sku) => {
  e.innerHTML = "adding...";

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: vid,
            quantity: 1,
            properties: {
              _quick_view_product: `Quick View ${sku}`,
            },
          },
        ],
      }),
    });

    // Fetch updated cart to get the item count
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    // Update the count bubble
    const bubbleCount = document.querySelector('.brave-header__cart-count');
    if (bubbleCount) {
      bubbleCount.textContent = cart.item_count;
    }
    const bubbleScreenReader = document.querySelector('#cart-icon-bubble .visually-hidden');
    if (bubbleScreenReader) {
      bubbleScreenReader.textContent = `${cart.item_count} items`;
    }

    e.innerHTML = "Added";
    const addToCartContainer = document.querySelector(".quick-view__atc");
    const checkout = document.createElement("a");
    checkout.innerHTML = "Ready to checkout?";
    checkout.setAttribute("href", "/checkout");
    addToCartContainer.append(checkout);

  } catch (err) {
    console.error(err);
    window.location.reload();
  }
};

let activeImageIndex = 0;
const resetLoading = () => {
  loadingElList.forEach((el) => {
    el.innerHTML = "";
    activeImageIndex = 0;
    if (!el.classList.contains("loading-animation"))
      el.classList.add("loading-animation");
  });
};

const quickViewChangeImage = (direction) => {
  const imageBlocks = document.querySelectorAll(".quick-view__image-block");
  let activeEl = document.querySelector(
    ".quick-view__image-block.active-image"
  );
  if (imageBlocks) {
    if (direction == "previous" && activeImageIndex > 0) {
      activeEl.classList.remove("active-image");
      activeImageIndex--;
      imageBlocks[activeImageIndex].classList.add("active-image");
    } else if (
      direction == "next" &&
      imageBlocks.length - 1 > activeImageIndex
    ) {
      activeEl.classList.remove("active-image");
      activeImageIndex++;
      imageBlocks[activeImageIndex].classList.add("active-image");
    }
  }
};
